import axios from "axios";
import SupplierProduct from "@/features/SupplierEvents/SupplierProduct";

class SupplierProductCacheEntry {
    public products: SupplierProduct[] = [];
    public expiration: Date = new Date(0);
}

export class SupplierProductService {
    private supplierProductURL = "/api/v1/supplierproducts";
    private supplierProductsCache: { [key: string]: SupplierProductCacheEntry } = {};

    async getSupplierProducts(supplierID: string): Promise<SupplierProduct[]> {
        const now = new Date();
        let cacheEntry = this.supplierProductsCache[supplierID];

        //if we haven't seen this supplier before, make a new entry and put it in the cache
        if (cacheEntry == null) {
            console.log("Adding new SE product cache entry for: ", supplierID);
            cacheEntry = new SupplierProductCacheEntry();
        }

        if (now >= cacheEntry.expiration) {
            //the entry is expired
            console.log("Refreshing product cache for product: ", supplierID);
            //We don't have the data or it is expired, fetch it from the server.
            const path = `${this.supplierProductURL}/supplier/${supplierID}`;
            const response = await axios.get(path);
            cacheEntry.products = response.data;
            //Reset the cache expiration for 24 hours in the future.
            cacheEntry.expiration = new Date(now.getTime() + 86400000); //24 hours in milliseconds
            //Now that we have data, update the cache, in case this was our first time pulling this data.
            //this way if the request errors out, the cache will still be empty.
            this.supplierProductsCache[supplierID] = cacheEntry;
        }

        return cacheEntry.products;
    }
}
